export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS'
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'



// WEBPACK FOOTER //
// ./src/store/modules/admin/recommendations/types.js